// React
import { useEffect, useState } from 'react';

// Src
import Config from '@/config';
import { OpenAPI } from '@/infrastructure/api/core/OpenAPI';
import { useAppSelector } from '@/infrastructure/redux/hooks/useAppSelector';
import useUserQuery from './userUserQuery';

export const useAuthentication = () => {
    // Hooks
    const [isReady, setReady] = useState(false);
    const { loggedIn, loggedUserInfo, userId } = useAppSelector((state) => state.authenticationReducer);
    const userQuery = useUserQuery(loggedIn ? userId : undefined, loggedUserInfo?.access_token);

    // Effects
    useEffect(() => {
        if (loggedIn && userId) {
            OpenAPI.BASE = Config.BACKEND_API_URL || 'http://localhost:8080';
            OpenAPI.TOKEN = loggedUserInfo?.access_token;
            userQuery.refetch();
        }
        setReady(true);
    }, [loggedIn, userId]);

    return { loggedIn, user: userQuery.data?.data.detail || null, isReady, access_token: loggedUserInfo?.access_token };
};
